import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import type { Client } from '~/api/clients/types';

import { r, routes } from '~/providers/RouterProvider/router.routes';
import { cellLinkStyle, desktopTruncateStyle } from '~/styles/utilities.css';

import { contactsListStyle, moreContactsStyle } from './clientCell.css';

type Props = {
  client: Client;
};

export const ClientContactsCell = ({ client }: Props) => {
  const { t } = useTranslation(['clients']);

  if (client.clientType === 'private') return '–';

  const existingContacts = client.contacts.filter(({ deleted }) => !deleted);

  if (existingContacts.length === 0) return '–';

  return (
    <ul className={contactsListStyle}>
      {existingContacts.slice(0, existingContacts.length > 3 ? 2 : 3).map((contact) => (
        <li className={desktopTruncateStyle} key={contact.id}>
          <Link className={cellLinkStyle} to={r(routes.editContact, { clientId: client.id, contactId: contact.id })}>
            {contact.fullName}
          </Link>
        </li>
      ))}

      {existingContacts.length > 3 && (
        <li className={moreContactsStyle}>{t('clients:overview.moreContacts', { amount: existingContacts.length - 2 })}</li>
      )}
    </ul>
  );
};
